import {AbstractControl} from '@angular/forms';
import {isValidNumber, parse} from 'libphonenumber-js';

/*
 Validator for phone value
 */
export class PhoneValidator {
    static validate(c: AbstractControl) {
        let isValid = c.value == null || c.value.length === 0 || isValidNumber(parse(c.value));
        return isValid ? null : {phone: true};
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/validators/phone.validator.ts